import(/* webpackMode: "eager", webpackExports: ["formatCollectionSubNavLabel"] */ "/code/components/website/CollectionSubNavLinks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/code/components/website/NewsPage.js");
